module.exports = __webpack_public_path__ + "img/03.ada37056.jpg";